module.exports = __webpack_public_path__ + "static/07-c057eaa5852dc2fa02342208c77acf1d.jpg";